import colors from '../../colors.json';

function zeroOffset(values) {
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min;

  if (range === 0) return 0.5;
  if (max <= 0) return 0;
  if (min >= 0) return 1;

  return max / range;
}

export function buildOptions(dates, values, echarts) {
  const offset = zeroOffset(values);
  const good = colors['growth']['positive'];
  const bad = colors['growth']['negative'];

  const lineGradient = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 0, color: good },
    { offset: offset, color: good },
    { offset: offset, color: bad },
    { offset: 1, color: bad }
  ]);

  const areaGradient = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 0, color: good },
    { offset: offset, color: '#ffffff' },
    { offset: 1, color: bad }
  ]);

  return {
    grid: {
      left: 0, top: 0, right: 0, bottom: 0,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: dates,
      axisLabel: {
        showMaxLabel: true,
        alignMaxLabel: 'right',
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: { formatter: '{value}%' },
    },
    series: [{
      name: '90-Day Growth',
      type: 'line',
      smooth: true,
      data: values,
      lineStyle: {
        type: 'solid',
        color: lineGradient
      },
      areaStyle: {
        opacity: 0.2,
        color: areaGradient
      },
      markLine: {
        symbol: ['none', 'none'],
        label: { show: false },
        data: [{ yAxis: 0 }],
        lineStyle: {
          color: '#000',
          type: 'dashed'
        },
        emphasis: {
          disabled: true
        }
      }
    }]
  };
}
